import { lazy } from "react";

/** Lazy-load a module default export. */
export function lazyDefault(importFn) {
  return lazy(importFn);
}

/** Lazy-load a named export from a module. */
export function lazyNamed(importFn, exportName) {
  return lazy(() =>
    importFn().then((module) => ({
      default: module[exportName] ?? module.default,
    }))
  );
}

/** Lazy-load a named export from an npm package. */
export function lazyPackageNamed(packageImportFn, exportName) {
  return lazy(() =>
    packageImportFn().then((module) => ({
      default: module[exportName],
    }))
  );
}
